var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_595)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_35_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15 3H95V77H-15V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15 3H95V8.69064H-15V3ZM-15 14.3813H95V20.0719H-15V14.3813ZM-15 25.7626H95V31.4532H-15V25.7626ZM-15 37.1439H95V42.8345H-15V37.1439ZM-15 48.5468H95V54.2374H-15V48.5468ZM-15 59.9281H95V65.6187H-15V59.9281ZM-15 71.3094H95V77H-15V71.3094Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15 3H40V42.8345H-15V3Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.75026 33.0544L-5.60796 30.2848L-6.55143 33.0544H-9.38184L-7.08749 34.7205L-7.94519 37.4901L-5.60796 35.7807L-3.33505 37.4901L-4.21419 34.7205L-1.87696 33.0544H-4.75026ZM7.32187 33.0544L6.44273 30.2848L5.54214 33.0544H2.71173L5.00608 34.7205L4.14838 37.4901L6.44273 35.7807L8.75852 37.4901L7.90082 34.7205L10.1952 33.0544H7.32187ZM19.4369 33.0544L18.5149 30.2848L17.6572 33.0544H14.7624L17.1211 34.7205L16.2205 37.4901L18.5149 35.7807L20.8735 37.4901L19.9729 34.7205L22.2673 33.0544H19.4369ZM31.4876 33.0544L30.6299 30.2848L29.7293 33.0544H26.8774L29.1932 34.7205L28.3355 37.4901L30.6299 35.7807L32.9457 37.4901L32.0236 34.7205L34.3823 33.0544H31.4876ZM6.44273 19.293L5.54214 22.0626H2.71173L5.00608 23.7719L4.14838 26.4982L6.44273 24.8105L8.75852 26.4982L7.90082 23.7719L10.1952 22.0626H7.32187L6.44273 19.293ZM-5.60796 19.293L-6.55143 22.0626H-9.38184L-7.08749 23.7719L-7.94519 26.4982L-5.60796 24.8105L-3.33505 26.4982L-4.21419 23.7719L-1.87696 22.0626H-4.75026L-5.60796 19.293ZM18.5149 19.293L17.6572 22.0626H14.7624L17.1211 23.7719L16.2205 26.4982L18.5149 24.8105L20.8735 26.4982L19.9729 23.7719L22.2673 22.0626H19.4369L18.5149 19.293ZM30.6299 19.293L29.7293 22.0626H26.8774L29.1932 23.7719L28.3355 26.4982L30.6299 24.8105L32.9457 26.4982L32.0236 23.7719L34.3823 22.0626H31.4876L30.6299 19.293ZM-5.60796 8.34444L-6.55143 11.0708H-9.38184L-7.08749 12.7801L-7.94519 15.5281L-5.60796 13.8187L-3.33505 15.5281L-4.21419 12.7801L-1.87696 11.0708H-4.75026L-5.60796 8.34444ZM6.44273 8.34444L5.54214 11.0708H2.71173L5.00608 12.7801L4.14838 15.5281L6.44273 13.8187L8.75852 15.5281L7.90082 12.7801L10.1952 11.0708H7.32187L6.44273 8.34444ZM18.5149 8.34444L17.6572 11.0708H14.7624L17.1211 12.7801L16.2205 15.5281L18.5149 13.8187L20.8735 15.5281L19.9729 12.7801L22.2673 11.0708H19.4369L18.5149 8.34444ZM30.6299 8.34444L29.7293 11.0708H26.8774L29.1932 12.7801L28.3355 15.5281L30.6299 13.8187L32.9457 15.5281L32.0236 12.7801L34.3823 11.0708H31.4876L30.6299 8.34444Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_595"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_35_595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 74,
    fill: "white",
    transform: "translate(-15 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa-flag.33eafded6540c69fe75dd1510bcaffe6.svg";
export { ForwardRef as ReactComponent };